import { StateCreator } from 'zustand'

export interface OrganizationSwitcherSlice {
  organizationSwitcherVisible: boolean
  showOrganizationSwitcher: () => void
  hideOrganizationSwitcher: () => void
}

export const createOrganizationSwitcherSlice: StateCreator<
  OrganizationSwitcherSlice
> = (set) => ({
  organizationSwitcherVisible: false,
  showOrganizationSwitcher: () => set({ organizationSwitcherVisible: true }),
  hideOrganizationSwitcher: () => set({ organizationSwitcherVisible: false }),
})
